module.exports = __webpack_public_path__ + "img/icon8.f38843dc.png";